<script>
import Layout from '@layouts/main'
import api from '@utils/api'
import formatDate from '@utils/format-date'
import Role from './role'
import TablePaginator from '@components/paginator'
import { cloneDeep } from 'lodash'

export default {
  name: 'Roles',
  components: { Layout, Role, TablePaginator },
  data() {
    return {
      modelName: 'roles',
      isLoading: false,
      headers: [
        { text: 'name', value: 'translatedName', sortable: true },
        { text: 'description', value: 'translatedDescription', sortable: true },
      ],
      rowsPerPage: [10, 25, 50],
      page: 1,
      sortBy: 'name',
      descending: false,
      content: [],
      pagination: {},
      dialog: false,
      currentRole: {},
    }
  },
  watch: {
    '$i18n.locale': function(newVal, oldVal) {
      if (this.content) {
        this.content.map(item => {
          item.translatedDescription = this.$t(item.i18nKeyDescription)
          item.translatedName = this.$t(item.i18nKeyName)
          return item
        })
      }
    },
  },
  created() {
    this.fetchData()
    this.getPaginator()
  },
  methods: {
    fetchData() {
      this.isLoading = true
      api.getRoles({ page: 1, size: 9999 }).then(response => {
        this.content = response.content
          .filter(
            item =>
              item.code === 'SUPERUSER' ||
              item.code === 'GUEST' ||
              item.code === 'DICTIONARIES_OPERATOR' ||
              item.code === 'DOCUMENTS_OPERATOR' ||
              item.code === 'REPORTS_OPERATOR' ||
              item.code === 'EVENTS_OPERATOR'
          )
          .map(item => {
            item.translatedDescription = this.$t(item.i18nKeyDescription)
            item.translatedName = this.$t(item.i18nKeyName)
            return item
          })
        this.isLoading = false
      })
    },
    getValue(dictionaryName, value) {
      return this.$store.getters['data/getValueFromDictionary'](
        dictionaryName,
        value
      )
    },
    dateFormat(date) {
      return formatDate(date)
    },
    openRole(item) {
      this.currentRole = item
      this.dialog = true
    },
    closeRole() {
      this.dialog = false
      this.currentRole = {}
    },
    getPaginator() {
      const pagination = this.$store.getters['pagination/get'](this.modelName)
      if (pagination) {
        this.pagination.page = pagination.page || 1
        this.pagination.sortBy = pagination.sortBy || this.sortBy
        this.pagination.descending = pagination.descending || this.descending
        this.pagination.rowsPerPage = pagination.rowsPerPage || 10
      } else {
        this.pagination.page = 1
        this.pagination.rowsPerPage = 10
      }
    },
    onPaginationChange(pagination) {
      this.pagination.page = pagination.page
      this.pagination.sortBy = pagination.sortBy
      this.pagination.descending = pagination.descending
      this.pagination.rowsPerPage = pagination.rowsPerPage
      this.$store.commit('pagination/SET', {
        name: this.modelName,
        pagination: cloneDeep(this.pagination),
      })
    },
  },
}
</script>

<template>
  <Layout>
    <v-data-table
      :headers="headers"
      :items="content"
      :pagination.sync="pagination"
      :loading="isLoading"
      :class="$style.sdTable"
      :rows-per-page-items="rowsPerPage"
      @update:pagination="onPaginationChange"
    >
      <template
        slot="headerCell"
        slot-scope="props">
        {{ $t(`label__${props.header.text}`) }}
      </template>
      <v-progress-linear
        slot="progress"
        height="2"
        color="blue"
        background-color="#E0E0E0"
        indeterminate
      />
      <template 
        slot="items" 
        slot-scope="props">
        <tr 
          :class="$style.sdEditRow" 
          @click="openRole(props.item)">
          <td>{{ props.item.translatedName }}</td>
          <td>{{ $t(props.item.translatedDescription) }}</td>
        </tr>
      </template>
    </v-data-table>
    <role
      :item="currentRole" 
      :dialog="dialog" 
      @close-dialog="closeRole" />
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.sdTable {
  border: 1px solid #dfdfdf;

  th {
    outline: none;
  }
}
.sdEditRow {
  cursor: pointer;
}
.sdBorder {
  border: 1px solid #dfdfdf;
  border-bottom: none;
}
</style>
